import React from "react";
import { useNavigate } from "react-router-dom";
import { colors, fonts } from "../theme";
import { View, Text, Card, Button, Press, ScreenHeader, EmptyState } from "../ui";
import { Icon } from "../Icon";
import { useI18n } from "../i18n";
import { useAppState } from "../state";
import { questionById, t } from "../content";

export default function Mistakes() {
  const navigate = useNavigate();
  const { tr, lang } = useI18n();
  const { state } = useAppState();
  const items = state.mistakes.map((id) => questionById(id)).filter(Boolean);
  return (
    <View style={{ flex: 1, minHeight: "100vh", backgroundColor: colors.surfaceSecondary }}>
      <ScreenHeader title={tr("myMistakes")} onBack={() => navigate(-1)} />
      {items.length === 0 ? (
        <EmptyState icon="confetti" title={tr("noMistakes")} />
      ) : (
        <View style={{ padding: 20 }}>
          <View style={{ marginBottom: 16 }}>
            <Button testID="practice-mistakes-btn" title={`${tr("practiceMistakes")} (${items.length})`} icon="lightning" onPress={() => navigate("/session?mode=mistakes")} />
          </View>
          {items.map((q, i) => (
            <Card key={q.id + i} style={{ flexDirection: "row", alignItems: "center", gap: 12, marginBottom: 10 }}>
              <View style={{ width: 34, height: 34, borderRadius: 17, backgroundColor: colors.errorSurface, alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <Icon name="warning" size={18} color={colors.error} weight="fill" />
              </View>
              <Text numberOfLines={2} style={{ flex: 1, fontWeight: fonts.medium, fontSize: 14, color: colors.onSurface }}>{t(q.prompt, lang)}</Text>
            </Card>
          ))}
        </View>
      )}
    </View>
  );
}
